import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "m9.837 16.213 6.849-4.411-6.849-4.41v8.82Zm2.446 5.391a9.51 9.51 0 0 1-3.815-.772 9.88 9.88 0 0 1-3.106-2.095 9.9 9.9 0 0 1-2.092-3.112 9.56 9.56 0 0 1-.77-3.823c0-1.356.257-2.63.77-3.823a9.9 9.9 0 0 1 2.092-3.112 9.878 9.878 0 0 1 3.106-2.095A9.51 9.51 0 0 1 12.283 2a9.51 9.51 0 0 1 3.816.772 9.879 9.879 0 0 1 3.106 2.095 9.9 9.9 0 0 1 2.091 3.112 9.56 9.56 0 0 1 .77 3.823c0 1.356-.256 2.63-.77 3.823a9.9 9.9 0 0 1-2.091 3.112 9.88 9.88 0 0 1-3.106 2.095 9.51 9.51 0 0 1-3.816.772Z"
    }, null, -1)
  ])))
}
export default { render: render }